import { AiOutlineClose } from "react-icons/ai";
import ImgTag from "../Helpers/ImgTag";
import { useTranslation } from "next-i18next";

function Branches({ branches }) {
  const { t } = useTranslation("product");
  return (
    <ul className="mt-2 mb-1">
      {branches?.map((branch, i) => (
        <li
          key={i}
          className="flex items-center justify-between p-2 mb-2 border rounded-md"
        >
          <div className="text-base">
            <h5 className="mb-1 font-semibold">
              {t("BranchName")} :{" "}
              <span className="font-normal">{branch?.location.name || ""}</span>{" "}
            </h5>
            <h5 className="mb-1 font-semibold">
              {t("Address")} :{" "}
              <span className="font-normal">
                {branch?.location.address || ""}
              </span>{" "}
            </h5>
          </div>

          {branch?.location?.lat && branch?.location?.lng && (
            <a
              href={`https://www.google.com/maps?q=${branch?.location?.lat},${branch?.location?.lng}`}
              target="_blank"
              className={`w-14 flex items-center justify-center bg-white text-red rounded-md `}
            >
              <ImgTag
                // src="/svgs/location-pin-select-city.svg"
                src={`${process.env.NEXT_PUBLIC_CLOUD_FLAIR}/w=25&h=25,fit=contain,format=auto,quality=75/location-pin-select-city.svg`}
                className="object-contain w-auto h-8"
                height={1000}
                width={1000}
                alt="Branch Location Img!"
              />
            </a>
          )}
        </li>
      ))}
    </ul>
  );
}

export default Branches;

export const AllBranches = ({ setShowBranches, branches, city }) => {
  const { t } = useTranslation("product");
  return (
    <div className="fixed bg-lightblack z-[5000] top-0 left-0 h-screen w-screen flex items-center justify-center">
      <div className="bg-white p-2 rounded-md w-[570px] max-[570px]:w-[98%] mx-auto max-h-[75vh] overflow-y-auto">
        <div className="flex items-center justify-between pb-1 border-b">
          <h1 className="text-xl font-bold text-emerald-600">
            {t("AvailableIn")}{" "}
            {
              branches?.items.filter((item) => item.location.city === city)
                .length
            }{" "}
            {t("Branches")}
          </h1>
          <AiOutlineClose
            onClick={() => setShowBranches(false)}
            size="22px"
            className="cursor-pointer text-red"
          />
        </div>
        <Branches
          branches={branches?.items.filter(
            (item) => item.location.city === city
          )}
        />
      </div>
    </div>
  );
};
